import { reject, resolve } from 'redux-optimist-promise';
import { get } from 'lodash';
import createReducer from 'Store/utils/createReducer';
import type { AllInclusiveServicesData } from 'Store/price-remote/all-inclusive-services/allInclusiveServices.helper';
import 'Store/price-remote/all-inclusive-services/allInclusiveServices.helper';
import { ALL_INCLUSIVE_SERVICES_REQUEST } from 'Store/price-remote/constants';
type AllInclusiveServicesRequestResolvedAction = OptimisticResolvedAction<{
  allInclusiveServices: AllInclusiveServicesData;
}>;
export type AllInclusiveServicesState = {
  isLoading: boolean;
  data: AllInclusiveServicesData;
  lastRequestId: number;
};
const initialState: AllInclusiveServicesState = {
  isLoading: true,
  data: [],
  lastRequestId: -1,
};
export const allInclusiveServicesReducer = createReducer(initialState, {
  [ALL_INCLUSIVE_SERVICES_REQUEST](
    state: AllInclusiveServicesState,
    action: AllInclusiveServicesRequestResolvedAction,
  ): AllInclusiveServicesState {
    return { ...state, isLoading: true, lastRequestId: get(action, 'optimist.id', -1) };
  },

  [resolve(ALL_INCLUSIVE_SERVICES_REQUEST)](
    state: AllInclusiveServicesState,
    action: AllInclusiveServicesRequestResolvedAction,
  ): AllInclusiveServicesState {
    // If there is another request in progress
    if (get(action, 'optimist.id', -1) !== state.lastRequestId) {
      return state;
    }

    return { ...state, isLoading: false, data: action.payload.allInclusiveServices };
  },

  [reject(ALL_INCLUSIVE_SERVICES_REQUEST)](
    state: AllInclusiveServicesState,
  ): AllInclusiveServicesState {
    return { ...state, isLoading: false };
  },
});
